import React from "react";


export default function SignIn () {
    return(
        <div>Sign in</div>
    )
}